<template>
    <div class="box-login over-inherit mx-auto mt-5 py-4">
        <div class="box-icon-login text-center"><i class="login-personaje icon-usuario-1 d-inline-flex align-items-center justify-content-center rounded-circle bg-morado-base texto-blanco font-36"></i></div>
        <h2 class="texto-blanco my-4 text-center">Recupera tu contraseña</h2>
        <div class="form-group bg-blanco radio-8 mb-0">
            <input class="form-control-login text-center w-100" v-model="$v.correo.$model" type="text" placeholder="Ingresa tu correo">
        </div>
        <div class="font-10 texto-blanco text-center font-italic mt-1" v-show="$v.correo.$error">Ingrese un correo válido</div>
        <button v-on:click="resetPassword" class="btn btn-lg w-100 btn-morado-base texto-blanco px-4 radio-8 mt-3" type="submit">Enviar</button>
    </div>
</template>
<script>
    import { modalnotificaciones } from '@resources/helpers.js'
    import { required, email } from '@public/validators.min'
    export default {
        data (){
            return {
                correo: ''
            }
        },
        validations: {
            correo: { required, email },
        },
        methods: {
            resetPassword () {
                let titulomodal = 'Aviso'
                let self = this
                self.$v.$touch()
                if (self.$v.$invalid) {
                    modalnotificaciones(titulomodal, 'Complete los campos obligatorios')
                } else {
                    axios
                        .post('recuperarcontrasena',{
                            correo: self.correo,
                        })
                        .then(response => {
                            Object.assign(this.$data, this.$options.data.call(this))
                            self.$v.$reset()
                            modalnotificaciones(titulomodal, 'Hemos enviado un correo')
                        })
                        .catch(error => {
                            let codeerror = error.response.status
                            if(codeerror === 400){
                                modalnotificaciones(titulomodal, 'No se encontró el correo electrónico en el sistema.')
                            }else{
                                modalnotificaciones(titulomodal, 'Verifique los campos del formulario')
                            }
                        })
                        .finally()
                }
            }
        }
    }
</script>
